import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    html {
      margin: 0;
      padding: 0;
      height: 100%;
      box-sizing: border-box;
    }

    *,
    *:before,
    *:after {
      box-sizing: inherit;
      outline: 0;
    }

    body {
      margin: 0;
      padding: 0;
      height: 100%;
      scrollbar-width: thin !important;
    }

    ul {
      margin: 0;
      padding: 0;
      list-style-type: none;
    }

    img {
      width: auto;
      height: auto;
    }

    p {
      margin: 0;
      padding: 0;
    }

    #root {
      height: 100%;
    }

    /* ************************************* */
    /* FONTS                                 */     
    /* ************************************* */

    @font-face {
      font-family: 'Bryant Web Regular';
      src: url('https://assets.talentry.io/fonts/Bryant2Web/Bryant2Web_EOT/BryantWebRegular.eot');
      src: url('https://assets.talentry.io/fonts/Bryant2Web/Bryant2Web_EOT/BryantWebRegular.eot?#iefix') format('embedded-opentype'),
          url('https://assets.talentry.io/fonts/Bryant2Web/Bryant2Web_WOFF/BryantWebRegular.woff') format('woff');
      font-weight: 200;
    }

    @font-face {
      font-family: 'Bryant Web Medium';
      src: url('https://assets.talentry.io/fonts/Bryant2Web/Bryant2Web_EOT/BryantWebMedium.eot');
      src: url('https://assets.talentry.io/fonts/Bryant2Web/Bryant2Web_EOT/BryantWebMedium.eot?#iefix') format('embedded-opentype'),
          url('https://assets.talentry.io/fonts/Bryant2Web/Bryant2Web_WOFF/BryantWebMedium.woff') format('woff');
      font-weight: 200;
    }

    @font-face {
      font-family: 'Bryant Web Bold';
      src: url('https://assets.talentry.io/fonts/Bryant2Web/Bryant2Web_EOT/BryantWebBold.eot');
      src: url('https://assets.talentry.io/fonts/Bryant2Web/Bryant2Web_EOT/BryantWebBold.eot?#iefix') format('embedded-opentype'),
          url('https://assets.talentry.io/fonts/Bryant2Web/Bryant2Web_WOFF/BryantWebBold.woff') format('woff');
      font-weight: 200;
    }

    @font-face {
      font-family: 'Bryant Pro Regular OLD';
      src: url('https://assets.talentry.io/fonts/BryantPro/BryantPro_EOT/BryantPro-Regular.eot');
      src: url('https://assets.talentry.io/fonts/BryantPro/BryantPro_EOT/BryantPro-Regular.eot?#iefix') format('embedded-opentype'),
          url('https://assets.talentry.io/fonts/BryantPro/BryantPro_WOFF/BryantPro-Regular.woff') format('woff');
      font-weight: 200;
    }

    @font-face {
      font-family: 'Bryant Pro Regular';
      src: url('https://assets.talentry.io/fonts/BryantProTest/BryantProTest_WOFF/BryantPro-Regular.woff') format('woff'), 
        url('https://assets.talentry.io/fonts/BryantProTest/BryantProTest_WOFF2/BryantPro-Regular.woff2') format('woff2'),
        url('https://assets.talentry.io/fonts/BryantProTest/BryantProTest_EOT/BryantPro-Regular.eot'),
        url('https://assets.talentry.io/fonts/BryantProTest/BryantProTest_EOT/BryantPro-Regular.eot?#iefix') format('embedded-opentype');
      font-weight: 200;
    }

    @font-face {
      font-family: 'Bryant Pro Medium OLD';
      src: url('https://assets.talentry.io/fonts/BryantPro/BryantPro_EOT/BryantPro-Medium.eot');
      src: url('https://assets.talentry.io/fonts/BryantPro/BryantPro_EOT/BryantPro-Medium.eot?#iefix') format('embedded-opentype'),
          url('https://assets.talentry.io/fonts/BryantPro/BryantPro_WOFF/BryantPro-Medium.woff') format('woff');
      font-weight: 200;
    }

    @font-face {
      font-family: 'Bryant Pro Medium';
      src: url('https://assets.talentry.io/fonts/BryantProTest/BryantProTest_EOT/BryantPro-Medium.eot');
      src: url('https://assets.talentry.io/fonts/BryantProTest/BryantProTest_WOFF/BryantPro-Medium.woff') format('woff'), 
        url('https://assets.talentry.io/fonts/BryantProTest/BryantProTest_WOFF2/BryantPro-Medium.woff2') format('woff2'),
        url('https://assets.talentry.io/fonts/BryantProTest/BryantProTest_EOT/BryantPro-Medium.eot?#iefix') format('embedded-opentype');
      font-weight: 200;
    }

    @font-face {
      font-family: 'Bryant Pro Bold OLD';
      src: url('https://assets.talentry.io/fonts/BryantPro/BryantPro_EOT/BryantPro-Bold.eot');
      src: url('https://assets.talentry.io/fonts/BryantPro/BryantPro_EOT/BryantPro-Bold.eot?#iefix') format('embedded-opentype'),
          url('https://assets.talentry.io/fonts/BryantPro/BryantPro_WOFF/BryantPro-Bold.woff') format('woff');
      font-weight: 200;
    }

    @font-face {
      font-family: 'Bryant Pro Bold';
      src: url('https://assets.talentry.io/fonts/BryantProTest/BryantProTest_EOT/BryantPro-Bold.eot');
      src: url('https://assets.talentry.io/fonts/BryantProTest/BryantProTest_WOFF/BryantPro-Bold.woff') format('woff'), 
        url('https://assets.talentry.io/fonts/BryantProTest/BryantProTest_WOFF2/BryantPro-Bold.woff2') format('woff2'),
        url('https://assets.talentry.io/fonts/BryantProTest/BryantProTest_EOT/BryantPro-Bold.eot?#iefix') format('embedded-opentype');
      font-weight: 200;
    }
 
    /* ************************************* */
    /* TYPOGRAPHY                            */     
    /* ************************************* */

    body {
      /* font-family: 'Bryant Pro Regular'; */
      font-variant: tabular-nums;
      font-size: ${(props) => props.theme.typography.bodyText};
      color: ${(props) => props.theme.colors.greyDark};
    }

    span {
      /* font-family: 'Bryant Pro Regular'; */
      font-variant: tabular-nums;
      font-size: ${(props) => props.theme.typography.bodyText};
    }

    /* ************************************* */
    /* SCROLLBAR                             */     
    /* ************************************* */

    ::-webkit-scrollbar {
      width: 6px; height: 6px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px #D9D9D6; /* TyGreyLight */
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      border-radius: 6px;
      background: #63666A; /* TyGreyDark */
    }

    /* Handle Inactive */
    ::-webkit-scrollbar-thumb:window-inactive {
      background: #D9D9D6; /* TyGreyLight */
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover, 
    input:-webkit-autofill:focus, 
    input:-webkit-autofill:active  {
      -webkit-box-shadow: 0 0 0 30px white inset !important;
      -webkit-text-fill-color: #63666A !important; /* TyGreyDark */
    }
`;